<template>
  <artmisads-modal
    :open="open"
    title="Notice"
    :width="480"
    :maskClosable="false"
    :footer="null"
    :onCancel="close"
    :destroyOnClose="true"
  >
    <p class="notice-msg">
      Please save your Amazon Associate StoreID for amazon.com first.
    </p>
    <div class="notice-actions">
      <artmisads-button type="primary" @click="goUploadStoreId">Upload StoreID</artmisads-button>
    </div>
  </artmisads-modal>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const open = ref(false)

const close = () => {
  open.value = false
}

const goUploadStoreId = () => {
  close()
  router.push('/publisher/settings/associateTags')
}

const show = () => {
  open.value = true
}

defineExpose({ show })
</script>

<style scoped lang="less">
.notice-msg {
  margin: 0 0 20px;
  font-family: Sora, sans-serif;
  font-size: 14px;
  line-height: 22px;
  color: rgba(15, 6, 41, 0.85);
}

.notice-actions {
  display: flex;
  justify-content: center;
  padding-bottom: 8px;
}
</style>
